export const menuItems = [
  {
    id: 100,
    label: "menuitems.menu.text",
    isTitle: true,
    link: "/userroles",
    role: ["SuperAdmin"],
    subItems: [],
  },
  {
    id: 200,
    label: "menuitems.menu.text",
    isTitle: true,
    link: "/ouserbirimyetki",
    role: ["SuperAdmin"],
    subItems: [],
  },
  {
    id: 200,
    label: "menuitems.menu.text",
    isTitle: true,
    link: "/userswebsiteyetki",
    role: ["SuperAdmin"],
    subItems: [],
  },
];
